import React from "react";
import {
  Box,
  IconButton,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { Link, useSearchParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AppTable from "components/Shared/AppTable";

import { useLazyListShipmentForBulkCancelQuery } from "store/services/reportApi";

import { useTablePagination } from "hooks";
import ExportBulkCancelShipmentReport from "./PaymentReports/VendorReports/ExportBulkCancelShipmentReport";

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString();
};

const BulkCancelShipmentReportListScreen = () => {

  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();

  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [
    {
      title: "Reports",
      path: "/app/crm/reports/list",
    },
    {
      title: "Shipment Cancel Report",
    },
  ];

  const columns = [
    {
      name: "Shipment ID",
      selector: (row) => row.shipmentId,
      cell: (row) => row.shipmentId,
    },
    {
      name: "Added User",
      selector: (row) => row?.changeLogs?.[0]?.addedUser?.name || "N/A",
      cell: (row) => row?.changeLogs?.[0]?.addedUser?.name || "N/A",
    },
    {
      name: "Added Time",
      selector: (row) => row?.changeLogs?.[0]?.createdAt
        ? formatDateTime(row.changeLogs[0].createdAt)
        : "N/A",
      cell: (row) => row?.changeLogs?.[0]?.createdAt
        ? formatDateTime(row.changeLogs[0].createdAt)
        : "N/A",
    },
    {
      name: "Reason",
      selector: (row) => row?.changeLogs?.[0]?.changeLogs || "N/A",
      cell: (row) => row?.changeLogs?.[0]?.changeLogs || "N/A",
    },
    {
      name: "Actions",
      cell: (row) => (
        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          <Link to={`/app/crm/shipment/${row?._id}/detail`}>
            <IconButton size="small" aria-label="View Shipment" color="primary">
              <InfoOutlined />
            </IconButton>
          </Link>
        </Box>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  const [fetchShipment, { data: shipmentRes, isLoading, isFetching, error }] =
    useLazyListShipmentForBulkCancelQuery();

  // Handle numeric-keyed response by converting to array
  const shipmentData = React.useMemo(() => {
    if (!shipmentRes?.data) return [];
    return Object.values(shipmentRes.data);
  }, [shipmentRes?.data]);

  React.useEffect(() => {
    fetchShipment({
      page: currentPage,
      limit: perPage,
      ...(keyword && { keyword }),
    });
  }, [currentPage, fetchShipment, keyword, perPage]);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2,p:1 }}>
            <ExportBulkCancelShipmentReport />
          </Box>
        <AppTable
          columns={columns}
          data={shipmentData}
          progressPending={isLoading || isFetching}
          paginationServer
          paginationPerPage={perPage}
          paginationTotalRows={shipmentRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default BulkCancelShipmentReportListScreen;